( function ( $) {

	$( '.img-slider-wrapper' ).each(function(key, item) {
		var $prevArrow = $('.prev-arrow')[key];
		var $nextArrow = $('.next-arrow')[key];

		$(this).slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: $prevArrow,
			nextArrow: $nextArrow,
		})
	});

} )( jQuery );
